/**
 * YouTube OAuth Scopes
 *
 * ⚠️ PRE-VERIFICATION WARNING:
 * Until Google OAuth consent screen is verified, users will see this scary message:
 *
 *   "This app isn't verified"
 *   "This app hasn't been verified by Google yet. Only proceed if you
 *    know and trust the developer."
 *   [Back to safety]  [Advanced]
 *
 * Users must click "Advanced" → "Go to [App Name] (unsafe)" to proceed.
 *
 * This warning appears for ALL users (including test users) until verification
 * is approved (7-14 days). After approval, the warning disappears.
 *
 * See /backend/OAUTH_SCOPES.md for detailed documentation and launch strategy.
 */

export const SCOPE = [
  'https://www.googleapis.com/auth/youtube.readonly', // Read channel/video data
  'https://www.googleapis.com/auth/youtube.upload', // Upload videos
  'https://www.googleapis.com/auth/youtube.force-ssl', // Caption uploads + playlist management
  'https://www.googleapis.com/auth/yt-analytics.readonly', // Read video/channel analytics
]
// Note: existing connected accounts won't have `youtube.force-ssl` and need to
// re-authorize for caption/playlist features to work. The publish path
// gracefully degrades (logs + continues) if the scope is missing.
